import { render, staticRenderFns } from "./mod1.vue?vue&type=template&id=ba9f06fa&scoped=true&"
import script from "./mod1.vue?vue&type=script&lang=js&"
export * from "./mod1.vue?vue&type=script&lang=js&"
import style0 from "./mod1.vue?vue&type=style&index=0&id=ba9f06fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9f06fa",
  null
  
)

export default component.exports